<style lang="scss" scoped>
  .opera-btn-group .advanced-query-form > .el-row {
    display: block;
    .oms-form-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div :class="{up:!showSearch}" class="opera-btn-group ">
    <form onsubmit="return false">
      <div class="opera-icon ">
        <el-row>
          <el-col :span="13">
            <div v-show="!showSearch">
              <el-col :span="6" class="text-right" style="padding-right: 5px">
                货主订单号
              </el-col>
              <el-col :span="16">
                <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4" v-show="!showSearch">
            <div>
              <oms-form-row :span="6" label="">
                <el-button @click="searchInOrder" native-type="submit" type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
              </oms-form-row>
            </div>
          </el-col>
          <el-col :span="!showSearch ? 7 : 24 " class="opera-btn">
            <span @click="showSearch = !showSearch" class="pull-right switching-icon">
            <i class="el-icon-arrow-up"></i>
            <span v-show="showSearch">高级搜索</span>
            <span v-show="!showSearch">高级搜索</span>
           </span>
          </el-col>
        </el-row>
      </div>
    </form>
    <el-form class="advanced-query-form clearfix" onsubmit="return false"
             v-show="showSearch">
      <el-row>
        <el-col :span="8">
          <oms-form-row :span="6" label="货主订单号">
            <oms-input placeholder="请输入货主订单号" type="text" v-model.trim="searchCondition.orderNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8" v-show="$route.meta.role !== 'org'">
          <oms-form-row :span="6" label="货主">
            <org-select :list="upOrgList" :remote-method="queryUpOrgList"
                        placeholder="请输入名称/拼音首字母缩写/系统代码搜索货主" v-model="searchCondition.upstreamOrgId"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="货品主档">
            <goods-select :list="dhsGoodsList" :remote-method="queryDhsGoods"
                          placeholder="请输入名称搜索货品主档" v-model="searchCondition.goodsId"></goods-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="5" label="批号">
            <el-select :remoteMethod="queryDhsBatchNumbers" clearable filterable placeholder="请输入批号名称搜索批号"
                       remote v-model="searchCondition.batchNumberId">
              <el-option :key="item.id" :label="item.batchNumber" :value="item.id" v-for="item in batchNumberList">
                {{ item.batchNumber }}
              </el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="业务类型">
            <el-select clearable placeholder="请选择业务类型" type="text" v-model="searchCondition.bizType">
              <el-option :key="item.key" :label="item.label" :value="item.key"
                         v-for="item in bizTypes"></el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8" v-show="!($route.meta.role === 'org' && $route.meta.type === 0)">
          <oms-form-row :span="6" label="去向单位">
            <org-select :list="downOrgList" :remote-method="queryDownList"
                        placeholder="请输入名称/拼音首字母缩写/系统代码搜索去向单位" v-model.trim="searchCondition.downstreamOrgId"/>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="去向单位订单号">
            <oms-input placeholder="请输入去向订单号" type="text" v-model="searchCondition.orderThirdNo"></oms-input>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row :span="6" label="状态">
            <el-select clearable placeholder="请选择状态" type="text" v-model="searchCondition.status">
              <el-option :key="item.key" :label="item.label" :value="item.key"
                         v-for="item in orderStatus"></el-option>
            </el-select>
          </oms-form-row>
        </el-col>
        <el-col :span="8">
          <oms-form-row label="业务时间" :span="5">
            <el-col :span="24">
              <el-date-picker
                v-model="completeTimes"
                type="datetimerange"
                placeholder="请选择业务时间">
              </el-date-picker>
            </el-col>
          </oms-form-row>
        </el-col>
        <!--<el-col :span="8">-->
        <!--<oms-form-row label="下单时间" :span="5">-->
        <!--<el-col :span="24">-->
        <!--<el-date-picker-->
        <!--v-model="createdTimes"-->
        <!--type="datetimerange"-->
        <!--placeholder="请选择">-->
        <!--</el-date-picker>-->
        <!--</el-col>-->
        <!--</oms-form-row>-->
        <!--</el-col>-->
        <el-col :span="8">
          <oms-form-row :span="6" label="">
            <el-button @click="searchInOrder" class="ml-15" native-type="submit" type="primary">查询</el-button>
            <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
          </oms-form-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import MethodsMix from '@/mixins/methodsMinix';
import utils from "@/tools/utils";

export default {
    props: {
      bizTypes: Array
    },
    mixins: [MethodsMix],
    data() {
      return {
        showSearch: false,
        createdTimes: '',
        completeTimes:'',
        orderStatus: [],
        searchCondition: {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          batchNumberId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: '',
          completeStartTime:'',
          completeEndTime:''
        }
      };
    },
  mounted() {
    this.orderStatus=[];
    let orderStatus=utils['outBspOrderType'];
    Object.keys(orderStatus).forEach(key=>{
      let item=orderStatus[key];
      this.orderStatus.push({key:item.status,label:item.title});
    })
  },
  methods: {
      queryDhsBatchNumbers(val) {
        if (!this.searchCondition.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品主档');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.searchCondition.goodsId
        });
      },
      searchInOrder: function () {// 搜索
        // this.searchCondition.createStartTime = this.$formatAryTime(this.createdTimes, 0, 'YYYY-MM-DD HH:mm:ss');
        // this.searchCondition.createEndTime = this.$formatAryTime(this.createdTimes, 1, 'YYYY-MM-DD HH:mm:ss');
       this.searchCondition.completeStartTime = this.$formatAryTime(this.completeTimes, 0, 'YYYY-MM-DD HH:mm:ss');
       this.searchCondition.completeEndTime = this.$formatAryTime(this.completeTimes, 1, 'YYYY-MM-DD HH:mm:ss');
        this.$emit('search', this.searchCondition);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          status: '',
          upstreamOrgId: '',
          goodsId: '',
          batchNumberId: '',
          orderNo: '',
          bizType: '',
          downstreamOrgId: '',
          orderThirdNo: '',
          createStartTime: '',
          createEndTime: '',
          completeStartTime:'',
          completeEndTime:''
        };
        this.createdTimes = '';
        this.completeTimes='';
        Object.assign(this.searchCondition, temp);
        this.$emit('search', temp);
      }
    }
  };
</script>
